<div
    data-cy="sidebar-container"
    [ngClass]="{
        sidebar: true,
        extend: sidebarExtends,
        overlay: !responsive.isXLarge() && !responsive.isLarge()
    }"
    *ngIf="
        (!sidebarHidden && !responsive.isXSmall()) ||
        (sidebarExtends && !responsive.isXSmall())
    "
    (click)="onExtendSidebar()"
>
    <div class="top">
        <div
            data-cy="sidebar-dashboard-icon"
            (click)="onNavigateTo('/ops/dashboard'); $event.stopPropagation()"
            class="tab"
            [ngClass]="{
                link_active: isActiveLink('/ops/dashboard')
            }"
        >
            <mat-icon svgIcon="dashboard" />
            <span data-cy="sidebar-dashboard-label" class="link-title">{{
                "sidebar.menu.dashboard.label" | translate
            }}</span>
        </div>
        <div
            data-cy="sidebar-trend-graph-icon"
            (click)="$event.stopPropagation()"
            (click)="onNavigateTo('/ops/trendgraphs'); $event.stopPropagation()"
            class="tab"
            [ngClass]="{
                link_active: isActiveLink('/ops/trendgraphs')
            }"
        >
            <mat-icon svgIcon="trendgraph" />
            <span data-cy="sidebar-trend-graph-label" class="link-title">{{
                "sidebar.menu.trend-graph.label" | translate
            }}</span>
        </div>
        <div
            data-cy="sidebar-mimics-icon"
            *ngIf="mimicsListArray.length > 0"
            (click)="stopPropagation($event); toggleDropdown()"
            class="tab mimic-icon"
            [ngClass]="{
                link_active: isActiveLink('/ops/mimics') || isMimicDropdownOpen
            }"
        >
            <mat-icon svgIcon="mimics" />
            <span data-cy="sidebar-mimics-label" class="link-title">{{
                "sidebar.menu.mimics.label" | translate
            }}</span>
            <div
                class="dropdown-content"
                [style.display]="isMimicDropdownOpen ? 'block' : 'none'"
            >
                <span class="dropdown-title">{{
                    "sidebar.menu.mimics.dropdown-title" | translate
                }}</span>
                <app-mimics-views-menu
                    *ngFor="let mimic of mimicsListArray"
                    [mimic]="mimic"
                    [selectedGroup]="selectedGroup"
                    (groupSelected)="groupSelected($event)"
                    (toggleDropdown)="toggleDropdown($event)"
                    (onNavigateTo)="onNavigateView($event)"
                ></app-mimics-views-menu>
            </div>
            <app-mimics-groups
                *ngIf="showSubMimics"
                [groupData]="selectedGroup.mimics"
                (stopPropagationEvent)="stopPropagation($event)"
                (toggleDropdownEvent)="toggleDropdown($event)"
            >
            </app-mimics-groups>
        </div>

        <div
            data-cy="sidebar-alarms-icon"
            (click)="onNavigateTo('/ops/alarms'); $event.stopPropagation()"
            class="tab"
            [ngClass]="{
                link_active: isActiveLink('/ops/alarms')
            }"
        >
            <mat-icon svgIcon="alarm-page" />
            <span data-cy="sidebar-alarms-label" class="link-title">{{
                "sidebar.menu.alarms.label" | translate
            }}</span>
        </div>
        <div
            data-cy="sidebar-channels-icon"
            (click)="onNavigateTo('/ops/groups'); $event.stopPropagation()"
            class="tab"
            [ngClass]="{
                link_active: isActiveLink('/ops/groups')
            }"
        >
            <mat-icon svgIcon="channel-list" />
            <span data-cy="sidebar-channels-label" class="link-title">{{
                "sidebar.menu.channels.label" | translate
            }}</span>
        </div>
        <div
            data-cy="sidebar-graphs-icon"
            class="tab graphs-icon"
            (click)="onNavigateTo('/ops/graphs'); $event.stopPropagation()"
            class="tab"
            [ngClass]="{
                link_active: isActiveLink('/ops/graphs')
            }"
        >
            <mat-icon class="link-icon" svgIcon="graphs" />
            <span data-cy="sidebar-graphs-label" class="link-title">{{
                "sidebar.menu.graphs.label" | translate
            }}</span>
        </div>
        <div
            data-cy="sidebar-system-status-icon"
            (click)="
                onNavigateTo('/ops/system-status'); $event.stopPropagation()
            "
            class="tab"
            [ngClass]="{
                link_active: isActiveLink('/ops/system-status')
            }"
        >
            <mat-icon svgIcon="systemStatus" />
            <span data-cy="sidebar-system-status-label" class="link-title">{{
                "sidebar.menu.system-status.label" | translate
            }}</span>
        </div>
    </div>
    <div class="bottom">
        <a
            data-cy="sidebar-simulator-icon"
            class="tab"
            (click)="onOpenSimulator(); $event.stopPropagation()"
            *ngIf="runningOnCloud"
        >
            <mat-icon svgIcon="simulator" />
            <span data-cy="sidebar-simulator-label" class="link-title">{{
                "sidebar.menu.simulator.label" | translate
            }}</span>
        </a>
        <div
            data-cy="sidebar-settings-icon"
            (click)="onNavigateTo('/settings'); $event.stopPropagation()"
            class="tab"
            [ngClass]="{
                link_active: isActiveLink('/settings')
            }"
        >
            <mat-icon svgIcon="setting" />
            <span data-cy="sidebar-settings-label" class="link-title">{{
                "sidebar.menu.settings.label" | translate
            }}</span>
        </div>
        <div
            data-cy="sidebar-expansion-icon"
            class="tab tab-expansion"
            [ngclass]="[sidebarExtends && 'none-align-center']"
        >
            <mat-icon
                data-cy="sidebar-expanded-no-expansion-icon"
                class="expansion"
                [ngClass]="[sidebarExtends ? 'hidden' : 'visible']"
                svgIcon="keyboard-double-arrow-right"
            />
            <span data-cy="sidebar-expanded-label" class="link-title">{{
                "sidebar.menu.minimize.label" | translate
            }}</span>
            <mat-icon
                data-cy="sidebar-collapse-icon"
                class="expansion"
                svgIcon="keyboard-double-arrow-left"
                *ngIf="sidebarExtends"
            />
        </div>
    </div>
</div>
<div
    *ngIf="sidebarExtends && responsive.isXSmall()"
    (click)="onExtendSidebar()"
    class="dropdown-tabs"
>
    <div class="dropdown-tab">
        <mat-icon class="dropdown-tab-icon" svgIcon="systemStatus" />
        <span class="dropdown-tab-title">{{
            "sidebar.menu.system-status.label" | translate
        }}</span>
    </div>
    <div class="dropdown-tab" (click)="onNavigateTo('/settings')">
        <mat-icon class="dropdown-tab-icon" svgIcon="setting" />
        <span class="dropdown-tab-title">{{
            "sidebar.menu.settings.label" | translate
        }}</span>
    </div>
    <div class="dropdown-tab" (click)="onOpenSimulator()">
        <mat-icon class="dropdown-tab-icon" svgIcon="simulator" />
        <span class="dropdown-tab-title">{{
            "sidebar.menu.simulator.label" | translate
        }}</span>
    </div>
</div>
